export default __webpack_public_path__ + "static/media/rsc-new-logo.d2ed61e5.webp";